// Pour le dashboard Patient
import React from "react";
import DashboardLayout from "../../pages/Dashboard";

const PatientDashboard: React.FC = () => {
  return <DashboardLayout role="patient" />;
};

export default PatientDashboard;